import { CircularProgress } from "@suraasa/placebo-ui"
import ErrorPage from "components/ErrorPage"
import { useEffect } from "react"
import { useEnrollments } from "utils/hooks/useEnrollments"

const url = "https://assets.suraasa.com/itu/student-catalog-2025.pdf"

const StudentCatalog = () => {
  const { hasMed } = useEnrollments()

  useEffect(() => {
    if (!hasMed) return

    if (url) window.location.replace(url)
  }, [hasMed])

  if (hasMed === undefined) {
    return (
      <div className="flex items-center justify-center p-5">
        <CircularProgress />
      </div>
    )
  }

  if (!hasMed) {
    return <ErrorPage errorStatus={404} />
  }

  return (
    <div className="flex items-center justify-center p-5">
      <CircularProgress />
    </div>
  )
}

export default StudentCatalog
